import { api } from "@/api";
import { CajaApertura } from "@/shared/types/caja-apertura";
import { TransferenciaRequest } from "@/shared/types/transferencia";
import { sleep } from "@/shared/utils";

export interface CloseCajaRequest {
    transferenciaReal: TransferenciaRequest
}

export async function closeCaja(request: CloseCajaRequest): Promise<CajaApertura> {
    await sleep(1000);
    const response = await api.post("caja_actual/close", request);
    return response.data;
}